import { cardLightTheme } from './light-theme';
// Card component currently doesn't have a dark theme
export const cardDarkTheme = cardLightTheme;
//# sourceMappingURL=dark-theme.js.map